import { getInvoices } from '../../../HttpRequests/invoices'
import { loadInvoices } from '../State/project'
import { setFetching } from '../State/fetching'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async (dispatch) => {

  const { id } = getProps().match.params

  const params = {
    'filter[project_id]': id,
    include: 'project,valuation,retentionPayment',
  }

  dispatch(setFetching(true))

  try {

    const response = await getInvoices({ id, params })

    dispatch(loadInvoices(response.data.data))

  } catch (error) {

    handleException(error)

  } finally {

    dispatch(setFetching(false))

  }

}
